import React from 'react';
import PropTypes from 'prop-types';

const TextBox = ({
  input,
  placeholder,
  type,
  maxLength,
  min,
  max,
  step,
  meta: { touched, error },
  readOnly,
  disabled,
  className,
  style,
  onKeyPress,
}) => {
  const props = {
    ...input,
  };

  if (type === 'number') {
    props.step = step;

    if (min) {
      props.min = min;
    }
    if (max) {
      props.max = max <= 999999999999 ? max : 999999999999;
    }
  }

  if (type === 'textarea') {
    return (
      <div className={`form__form-group-input-wrap form__form-group-input-wrap--error ${className}`}>
        <textarea
          {...props}
          placeholder={placeholder}
          type={type}
          maxLength={maxLength}
          autoComplete="off"
          readOnly={readOnly}
          disabled={disabled}
          style={style}
          onKeyPress={onKeyPress}
        />
        {touched && error && <span className="form__form-group-error">{error}</span>}
      </div>
    );
  }

  return (
    <div className={`form__form-group-input-wrap form__form-group-input-wrap--error ${className}`}>
      <input
        {...props}
        placeholder={placeholder}
        type={type}
        maxLength={maxLength}
        autoComplete="off"
        readOnly={readOnly}
        disabled={disabled}
        style={style}
        onKeyPress={onKeyPress}
      />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
};

TextBox.propTypes = {
  input: PropTypes.shape({}).isRequired,
  style: PropTypes.shape({}),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  model: PropTypes.string,
  forceValidation: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  pattern: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
  }),
  onKeyPress: PropTypes.func,
};

TextBox.defaultProps = {
  style: {},
  placeholder: '',
  meta: {},
  type: 'text',
  min: '',
  max: '',
  step: '',
  maxLength: '',
  model: '',
  forceValidation: false,
  readOnly: false,
  disabled: false,
  className: '',
  pattern: '',
  onKeyPress: () => false,
};

export default TextBox;
